import { createRouter } from '@tanstack/react-router';
import { QueryProvider } from '@/lib/tanstack/react-query/query-provider';
import { routeTree } from './routeTree.gen';

export function getRouter() {
  return createRouter({ routeTree, Wrap: QueryProvider });
}

declare module '@tanstack/react-router' {
  interface Register {
    router: ReturnType<typeof getRouter>;
  }
}
